<script>
	import Icon from "../icons/Icon.svelte";

	export let show = false;
	export let isEditing = false;
	export let courierForm = {
		id: "",
		name: "",
		phone: "",
		vehicle_type: "moto",
		plate: "",
		fee_type: "fixed",
		default_fee: 5.00,
		daily_rate: 0.00
	};
	export let isSaving = false;

	export let onClose = () => {};
	export let onSave = () => {};
</script>

{#if show}
	<div class="modal-backdrop" on:click|self={onClose}>
		<div class="modal-card">
			<div class="modal-header">
				<div class="modal-title-group">
					<div class="modal-header-icon">
						<Icon name={isEditing ? 'edit' : 'user'} size={18} />
					</div>
					<div>
						<h3>{isEditing ? 'Editar Entregador' : 'Novo Entregador na Equipe'}</h3>
						<span class="modal-sub">Configurações de dados, veículo e modelo de remuneração</span>
					</div>
				</div>
				<button type="button" class="btn-close" on:click={onClose} aria-label="Fechar modal">
					<Icon name="x" size={16} />
				</button>
			</div>

			<div class="modal-body">
				<!-- Seção 1: Identificação Pessoal -->
				<div class="modal-section-title">
					<span>1. Identificação & Contato</span>
				</div>

				<div class="form-group">
					<label for="courierNameInput">Nome Completo do Entregador *</label>
					<input id="courierNameInput" type="text" class="form-input" placeholder="Ex: Carlos Eduardo da Silva" bind:value={courierForm.name}>
				</div>

				<div class="form-group">
					<label for="courierPhoneInput">WhatsApp / Telefone de Contato</label>
					<input id="courierPhoneInput" type="text" class="form-input" placeholder="Ex: (11) 99999-8888" bind:value={courierForm.phone}>
					<span class="field-hint">Utilizado para comunicação direta de pedidos e despachos</span>
				</div>

				<!-- Seção 2: Veículo -->
				<div class="modal-section-title">
					<span>2. Veículo & Identificação</span>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label for="courierVehicleSelect">Tipo de Veículo</label>
						<select id="courierVehicleSelect" class="form-select" bind:value={courierForm.vehicle_type}>
							<option value="moto">Moto</option>
							<option value="bike">Bicicleta</option>
							<option value="carro">Carro</option>
						</select>
					</div>

					<div class="form-group">
						<label for="courierPlateInput">Placa do Veículo</label>
						<input id="courierPlateInput" type="text" class="form-input plate-input" placeholder="Ex: BRA2E19" bind:value={courierForm.plate} style="text-transform:uppercase;">
					</div>
				</div>

				<!-- Seção 3: Remuneração -->
				<div class="modal-section-title">
					<span>3. Modelo de Remuneração</span>
				</div>

				<div class="form-group">
					<label for="courierFeeTypeSelect">Modelo de Ganho:</label>
					<select id="courierFeeTypeSelect" class="form-select" bind:value={courierForm.fee_type}>
						<option value="fixed">Taxa Fixa por Entrega Realizada</option>
						<option value="daily">Diária Fixa + Taxa por Entrega</option>
					</select>
				</div>

				<div class="form-row">
					<div class="form-group">
						<label for="courierFeeInput">Taxa Fixa por Entrega (R$)</label>
						<input id="courierFeeInput" type="number" step="0.01" min="0" class="form-input" placeholder="5.00" bind:value={courierForm.default_fee}>
						<span class="field-hint">Valor pago a cada viagem concluída</span>
					</div>

					<div class="form-group">
						<label for="courierDailyInput">Diária Fixa do Turno (R$)</label>
						<input id="courierDailyInput" type="number" step="1.00" min="0" class="form-input" placeholder="0.00" bind:value={courierForm.daily_rate}>
						<span class="field-hint">Garantia mínima diária (se houver)</span>
					</div>
				</div>
			</div>

			<div class="modal-footer">
				<button type="button" class="btn-cancel" on:click={onClose}>
					Cancelar
				</button>
				<button type="button" class="btn-save" disabled={isSaving} on:click={onSave}>
					{#if isSaving}
						<div class="loading-spinner-sm"></div>
						<span>Salvando...</span>
					{:else}
						<span>{isEditing ? 'Atualizar Dados' : 'Salvar e Entrar na Fila'}</span>
					{/if}
				</button>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-backdrop {
		position: fixed;
		inset: 0;
		background: rgba(15, 23, 42, 0.65);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		padding: 16px;
	}

	.modal-card {
		background: #FFFFFF;
		width: 100%;
		max-width: 520px;
		border-radius: var(--radius-lg, 18px);
		box-shadow: var(--shadow-modal, 0 20px 25px rgba(15, 23, 42, 0.15));
		overflow: hidden;
		display: flex;
		flex-direction: column;
		max-height: 90vh;
	}

	.modal-header {
		padding: 20px 24px;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #FFFFFF;
	}

	.modal-title-group {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.modal-header-icon {
		width: 38px;
		height: 38px;
		border-radius: 10px;
		background: var(--brand-primary-soft, #FFF7ED);
		color: var(--brand-primary, #FF6A00);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.modal-header h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.modal-sub {
		font-size: 12px;
		color: var(--text-muted, #94A3B8);
	}

	.btn-close {
		background: transparent;
		border: none;
		font-size: 16px;
		color: var(--text-muted, #64748B);
		cursor: pointer;
		width: 32px;
		height: 32px;
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background 0.15s ease;
	}

	.btn-close:hover {
		background: var(--neutral-surface-hover, #F1F5F9);
		color: var(--text-primary, #0F172A);
	}

	.modal-body {
		padding: 22px 24px;
		display: flex;
		flex-direction: column;
		gap: 16px;
		overflow-y: auto;
	}

	.modal-section-title {
		font-size: 11.5px;
		font-weight: 800;
		text-transform: uppercase;
		letter-spacing: 0.6px;
		color: var(--text-secondary, #64748B);
		border-bottom: 1px solid var(--neutral-border-subtle, #F1F5F9);
		padding-bottom: 6px;
		margin-top: 4px;
	}

	.form-group {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.form-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 14px;
	}

	.form-group label {
		font-size: 12.5px;
		font-weight: 700;
		color: var(--text-primary, #334155);
	}

	.form-input, .form-select {
		padding: 10px 14px;
		border: 1px solid var(--neutral-border, #CBD5E1);
		border-radius: var(--radius-md, 8px);
		font-size: 13.5px;
		font-family: inherit;
		outline: none;
		background: #FFFFFF;
		color: var(--text-primary, #0F172A);
		transition: border-color var(--transition-fast, 0.15s ease), box-shadow var(--transition-fast, 0.15s ease);
	}

	.form-input:focus, .form-select:focus {
		border-color: var(--brand-primary, #FF6A00);
		box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
	}

	.plate-input {
		font-weight: 700;
		letter-spacing: 1px;
	}

	.field-hint {
		font-size: 11px;
		color: var(--text-muted, #94A3B8);
	}

	.modal-footer {
		padding: 16px 24px;
		background: #F8FAFC;
		border-top: 1px solid var(--neutral-border, #E2E8F0);
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}

	.btn-cancel {
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #CBD5E1);
		padding: 10px 18px;
		border-radius: var(--radius-md, 8px);
		font-size: 13px;
		font-weight: 700;
		color: var(--text-secondary, #475569);
		cursor: pointer;
		transition: background 0.15s ease;
	}

	.btn-cancel:hover {
		background: var(--neutral-surface-hover, #F1F5F9);
	}

	.btn-save {
		background: var(--brand-primary, #FF6A00);
		border: none;
		padding: 10px 22px;
		border-radius: var(--radius-md, 8px);
		font-size: 13.5px;
		font-weight: 800;
		color: #FFFFFF;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: all 0.15s ease;
		box-shadow: 0 2px 8px rgba(255, 106, 0, 0.25);
	}

	.btn-save:hover:not(:disabled) {
		background: var(--brand-primary-hover, #E85A00);
	}

	.btn-save:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.loading-spinner-sm {
		width: 14px;
		height: 14px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-top-color: #FFFFFF;
		border-radius: 50%;
		animation: spin 0.8s linear infinite;
	}

	@keyframes spin {
		to { transform: rotate(360deg); }
	}
</style>
